module.exports = __webpack_public_path__ + "img/expectativas.1bba4733.png";